import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const phases = [{
    num: '1',
    title: 'Fase de Desinflamación',
    days: 'Días 1-7',
    desc: 'Limpiamos los agresores y pierdes el exceso de líquidos.'
  }, {
    num: '2',
    title: 'Fase de Activación',
    days: 'Días 8-14',
    desc: 'Aplicamos el Ciclado 3:1 para atacar la grasa rebelde.'
  }, {
    num: '3',
    title: 'Fase de Consolidación',
    days: 'Días 15-21',
    desc: 'Estabilizamos tu nueva energía y quemamos de forma automática.'
  }];
  return <section className="py-20 bg-[#FDF6F0]" data-id="element-101">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <FadeIn data-id="element-103">
          <h2 className="text-3xl md:text-4xl font-serif text-[#1A5C4C] text-center mb-16" data-id="element-104">
            Tu viaje de 21 días
          </h2>
        </FadeIn>

        <div className="relative" data-id="element-105">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-0.5 bg-[#C97B63]/30 -translate-y-1/2 z-0" data-id="element-106"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10" data-id="element-107">
            {phases.map((phase, idx) => <FadeIn key={idx} delay={idx * 0.2} data-id="element-108">
                <div className="bg-white p-8 rounded-2xl shadow-md text-center border-t-4 border-[#C97B63] relative h-full flex flex-col items-center" data-id="element-109">
                  <div className="w-12 h-12 bg-[#C97B63] text-white rounded-full flex items-center justify-center font-serif text-xl font-bold mb-6 shadow-lg" data-id="element-110">
                    {phase.num}
                  </div>
                  <span className="text-sm font-bold text-[#1A5C4C] uppercase tracking-wider mb-2" data-id="element-111">
                    {phase.days}
                  </span>
                  <h3 className="text-xl font-serif text-[#2A2A2A] mb-4" data-id="element-112">
                    {phase.title}
                  </h3>
                  <p className="text-[#2A2A2A] opacity-80" data-id="element-113">{phase.desc}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}